export default __webpack_public_path__ + "static/media/UmbrellaBlack.af30db1e.svg";